import getDevicePixelRatio from './utils/getDevicePixelRatio';

export const ONETWOTRIP_COUNTER = 'UA-21448683-1';
const GAPropertyName = 'ga';

let isLoaded = false;
let loadGoogleAnalyticsPromise;

// хранит все события, которые были выполнены до инициализации и выполняет после
let actions = {
  default: [],
};

function loadGoogleAnalytics() {
  if (!loadGoogleAnalyticsPromise) {
    loadGoogleAnalyticsPromise = new Promise((resolve, reject) => {
      if (typeof window === 'undefined') {
        reject();
      }

      (function (window, document, google, ga, script) {
        // eslint-disable-next-line no-param-reassign
        window.GoogleAnalyticsObject = ga;
        if (!window[GAPropertyName]) {
          // eslint-disable-next-line no-param-reassign
          window[GAPropertyName] = function () {
            // eslint-disable-next-line no-param-reassign
            window[GAPropertyName].q = window[GAPropertyName].q || [];
            // eslint-disable-next-line prefer-rest-params
            window[GAPropertyName].q.push(arguments);
          };
        }
        // eslint-disable-next-line no-param-reassign
        window[ga].l = 1 * new Date();
        // eslint-disable-next-line no-param-reassign
        script = document.createElement('script');

        // eslint-disable-next-line no-param-reassign
        script.async = 1;
        // eslint-disable-next-line no-param-reassign
        script.src = google;

        // eslint-disable-next-line no-param-reassign
        script.onload = function () {
          isLoaded = true;
          resolve();
        };

        const headNode = document.getElementsByTagName('head')[0];
        if (headNode) {
          headNode.appendChild(script);
        }
      })(window, document, '//www.google-analytics.com/analytics.js', GAPropertyName);
    });
  }

  return loadGoogleAnalyticsPromise;
}

let initGoogleAnalyticsPromises = {};

export function initGoogleAnalytics({ counterId, counterName = '' } = {}) {
  return loadGoogleAnalytics().then(() => {
    const initPromiseKey = counterName || 'default';

    if (!Object.keys(initGoogleAnalyticsPromises).includes(initPromiseKey)) {
      const initPromiseValue = new Promise((resolve, reject) => {
        try {
          const pixelRatio = getDevicePixelRatio();
          let gaCounter = counterId;

          if (!gaCounter) {
            gaCounter = ONETWOTRIP_COUNTER; // для всех вертикалей единый идентификатор
          }

          const track = window[GAPropertyName];

          track('create', gaCounter, 'auto', counterName);

          const setCommandName = counterName ? `${counterName}.set` : 'set';

          track(setCommandName, 'RetinaDisplay', pixelRatio);

          if (gaCounter === ONETWOTRIP_COUNTER) {
            const requireCommandName = counterName ? `${counterName}.require` : 'require';
            track(requireCommandName, 'ecommerce');
          }

          if (initPromiseKey in actions) {
            actions[initPromiseKey].forEach((action) => {
              track(...action);
            });
            actions[initPromiseKey] = [];
          }

          resolve();
        } catch (e) {
          window[GAPropertyName] = () => {};
          reject(e.message);
        }
      });

      initGoogleAnalyticsPromises = Object.assign(initGoogleAnalyticsPromises, {
        [`${initPromiseKey}`]: initPromiseValue,
      });
    }

    return Object.values(initGoogleAnalyticsPromises);
  });
}

export function gaWithCustomCounter(counterName = 'default') {
  return (...args) => {
    if (typeof window === 'undefined') {
      return;
    }
    if (isLoaded) {
      const track = window[GAPropertyName];
      track(...args);

      return;
    }
    if (counterName in actions) {
      actions[counterName].push(args);
    } else {
      actions = {
        ...actions,
        [`${counterName}`]: [args],
      };
    }
  };
}

export default gaWithCustomCounter();
